export class Share {

    public shareButton: string;
    public shareSize: number;
    public shareUrl: string;
    public shareTitle: string;
    public shareDescription: string;
    public shareImageUrl: string;
    public shareTagsString: string;

    constructor() {
    }
}

export class ShareButtons {

    public facebook: Share;
    public twitter: Share;
    public linkedIn: Share;
    public email: Share;
    public copy: Share;
    public whatsapp: Share;
    public google: Share;
    public tumblr: Share;
    public reddit: Share;
    public pinterest: Share;

    constructor() {
    }
}
